import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EnfoqueService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    list() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/enfoques`, { headers }).toPromise();
    }
    enfoqueById(id) {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/enfoques/enfoqueById?id=${id}`, { headers }).toPromise();
    }
    update(user, categoriaId) {
        return this.http.put(`${this.configService.API_URL}/enfoques/${categoriaId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/enfoques`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllCategorias() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/enfoques/todos`, { headers }).toPromise();
    }
    deleteEnfoque(enfoqueId) {
        return this.http.delete(`${this.configService.API_URL}/enfoques/${enfoqueId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
EnfoqueService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EnfoqueService_Factory() { return new EnfoqueService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EnfoqueService, providedIn: "root" });
